module.exports = __webpack_public_path__ + "img/water-level-new7.69c30464.gif";